import Page from "ui/Page";


export default function Layout({ children }) {

	const style = {
		body: {
			gap: { xs: 3.25, sm: 6.25 },
			overflow: "hidden"
		}
	};

	return (
		<Page maxWidth="lg">
			<Page.Body sx={style.body}>
				{children}
			</Page.Body>
		</Page>
	);
};